import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

const lastRouteKey = 'sensika-last-route';

@Injectable({ providedIn: 'root' })
export class LastRouteService {
  constructor(private router: Router) {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((event) => this.persist(event.urlAfterRedirects));
  }

  consumeLastRoute(): string | null {
    const url = localStorage.getItem(lastRouteKey);
    this.clearLastRoute();
    return url;
  }

  clearLastRoute(): void {
    localStorage.removeItem(lastRouteKey);
  }

  private persist(url: string): void {
    if (!this.shouldPersist(url)) return;
    localStorage.setItem(lastRouteKey, url);
  }

  private shouldPersist(url: string): boolean {
    if (!url) return false;
    if (url === '/') return false;
    if (url.startsWith('/auth')) return false;
    return true;
  }
}
